import { createContext } from "react";

export interface SectionIndicatorContext {
	sectionNumber: number | null;
	setSectionNumber: (section: number) => void;
}

export const SectionIndicatorContext = createContext<SectionIndicatorContext>({
	sectionNumber: 0,
	setSectionNumber: () => {},
});
